/**
 * API configuration for network requests.
 *
 * Loads base URL from environment variables (Vite-style env).
 * Falls back to default demo URLs if not provided.
 */

const API_BASE_URL = 'https://pilot.app-gateway.six3ro.com';

// --- Default headers ---
const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
};

// --- Exported config ---
export const API_CONFIG = {
  baseURL: API_BASE_URL,
  defaultHeaders: DEFAULT_HEADERS,
  withCredentials: true,
} as const;

export const HTTP_STATUS_CONFLICT = 409;
